import { useState } from 'react';
import { RouterProvider } from 'react-router-dom';

// routing
import router from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import Loader from 'ui-component/Loader';
import Notistack from 'ui-component/third-party/Notistack';

import ThemeCustomization from 'themes';
// import { dispatch } from 'store';
// import { getMenu } from 'store/slices/menu';

// auth provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import TourProvider from 'contexts/TourContext';
import TourManager from 'ui-component/TourManager';
import usePublicBranding from 'hooks/usePublicBranding';
import DeploymentNotFound from 'views/error/DeploymentNotFound';
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP ||============================== //

const App = () => {
    const [loading] = useState(true);
    const { isDeploymentNotFound, isLoading: brandingLoading } = usePublicBranding();

    // useEffect(() => {
    //     dispatch(getMenu()).then(() => {
    //         setLoading(true);
    //     });
    // }, []);

    if (!loading) return <Loader />;

    return (
        <ThemeCustomization>
            <RTLLayout>
                <Locales>
                    <NavigationScroll>
                        {brandingLoading ? (
                            <Loader />
                        ) : isDeploymentNotFound ? (
                            <DeploymentNotFound />
                        ) : (
                            <AuthProvider>
                                <>
                                    <Notistack>
                                        <TourProvider>
                                            <TourManager />
                                            <RouterProvider router={router} />
                                        </TourProvider>
                                        <Snackbar />
                                    </Notistack>
                                </>
                            </AuthProvider>
                        )}
                    </NavigationScroll>
                </Locales>
            </RTLLayout>
        </ThemeCustomization>
    );
};

export default App;
